import { createReducer, on } from "@ngrx/store"
import { createLicence, createLicenceFailure, createLicenceSuccess, deleteLicence, deleteLicenceFailure, deleteLicenceSuccess, getLicence, getLicenceSuccess } from "../actions/licence.action"


export interface LicenceState {
  licences: any
}


export const initialState: LicenceState = {
  licences: {
    content: [],
    totalPages: 0,
    totalElements: 0,
    pageable: {
      pageNumber: 0,
      pageSize: 20
    }
  }
}

export const licenceReducer = createReducer(
  initialState,
  on(createLicence, (state) => ({ ...state })),
  on(createLicenceSuccess, (state, { reponseDAO }) => ({ ...state, reponseDAO })),
  on(createLicenceFailure, (state, error) => ({ ...state, error })),
  on(getLicence, (state) => ({ ...state })),
  on(getLicenceSuccess, (state, { licences }) => ({ ...state, licences })),
  on(deleteLicence, (state) => ({ ...state })),
  on(deleteLicenceSuccess, (state) => ({ ...state })),
  on(deleteLicenceFailure, (state, error) => ({ ...state, error }))
)

